import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject, throwError } from "rxjs";
import { map, retry, catchError } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ItistudService {

  //  public SERVER_BASEURL = "http://localhost:5001/";
  // public SERVER_BASEURL = "https://grsnodetest.nimiquestionbank.in/";

  public SERVER_BASEURL = "https://nodetest.nimiquestionbank.in/";  // live working now 11:40 22/2/2021
  
  public SERVER_BASEURL11 = "https://api.ncvtmis.gov.in/nimi/api/getTrainees/";
  public SERVER_BASEURL1 = "https://api.ncvtmis.gov.in/nimi/api/getITIOnStateCode/";
  //public SERVER_BASEURL2= "https://api.ncvtmis.gov.in/nimi/api/UploadTraineeRegNumbers/";
  
  // public SERVER_BASEURL11 = "https://164.100.213.13/api/getTrainees/";
  // public SERVER_BASEURL1 = "https://164.100.213.13/api/getITIOnStateCode/";
  // //public SERVER_BASEURL2= "https://164.100.213.13/api/UploadTraineeRegNumbers/";
  public SERVER_BASEURL2 = "https://nimionlineadmission.in/dgt/upload_api.php";
  public ccref_url = "https://nimionlineadmission.in/AITTCBT-FEES22/Check_CCAvenue.php?ccav=";
  public ccref_url11 = "http://192.168.0.159/nimi_projects/SSW/ccavanue.php";
  public ccrefupdate_url =  "https://www.nimionlineadmission.in/AITTCBT-FEES22/Check_CCAvenuefull.php?ccav=";
  
  // ('https://sms.nettyfish.com/vendorsms/pushsms.aspx?apikey=9acf13b0-566f-47f9-b206-fe62af6f48da&clientId=a3b6b0ab-e393-44d4-aab0-1a3b69501f70&msisdn=' . $mobile . '&sid=NIMIAP&msg=Your%20OTP%20is%20'.$otp.'%20for%20reference%20number%20'.$regno.'%20-%20NIMI&fl=0&gwid=2')
  //9442507934
  public cc_mob = 'https://sms.nettyfish.com/vendorsms/pushsms.aspx?apikey=9acf13b0-566f-47f9-b206-fe62af6f48da&clientId=a3b6b0ab-e393-44d4-aab0-1a3b69501f70&msisdn=9597151452&sid=NIMIAP&msg=Your%20OTP%20is%20'+'77777'+'%20for%20reference%20number%20'+22222+'%20-%20NIMI&fl=0&gwid=2';
  
  // public cc_mob = 'https://sms.nettyfish.com/vendorsms/pushsms.aspx?apikey=9acf13b0-566f-47f9-b206-fe62af6f48da&clientId=a3b6b0ab-e393-44d4-aab0-1a3b69501f70&msisdn=9597151452&sid=NIMIAP&msg=Your OTP Number is '+9999+' for reference number '+'NAN123456'+'- NIMI&fl=0&gwid=2';
  
  
  
  constructor(private httpClient: HttpClient) { }
  
  
  checkITIstudlogin(args: any) {  
      return this.httpClient.post(this.SERVER_BASEURL + "checkITIstudlogin/", args).pipe(
        map((data) => {
  
          return data;
        }),
        retry(1),
        catchError(this.handleError)
      );
  }

  checkITIstudPay(args: any) {  
    return this.httpClient.post(this.SERVER_BASEURL + "checkITIstudPay/", args).pipe(
      map((data) => {

        return data;
      }),
      retry(1),
      catchError(this.handleError)
    );
}  

selectITIstud(args: any) {  
  return this.httpClient.post(this.SERVER_BASEURL + "selectITIstud/", args).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}  

insertITIstud(args: any) {  
  return this.httpClient.post(this.SERVER_BASEURL + "insertITIstud/", args).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
  
}

delITIstudPay(){
  return this.httpClient.get(this.SERVER_BASEURL + "delITIstudPay/").pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}

checkITIstudrollnum(args: any) {  
  return this.httpClient.post(this.SERVER_BASEURL + "checkITIstudrollnum/", args).pipe(
    map((data) => {

      return data;
    }),
    retry(1),
    catchError(this.handleError)
  );
}
  
    handleError(error: any) {
      let errorMessage = "";
      if (error.error instanceof ErrorEvent) {
        errorMessage = `${error.error.message}`;
      } else {
        // server-side error
        //errorMessage = `${error.status} <br /> Message: ${error.message}`;
        errorMessage = `Server Error<br /> Message: ${error.message}`;
      }
  
      return throwError(errorMessage);
    }
  
}
